import styled from 'styled-components';
import {desktopMedia} from '../../../../globalVariables/GlobalVariables';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const panel = styled.div`
    width: 100%;
    max-width: none;
    max-height: 90vh;
    ${dFlexColumn};
    background: var(--color-bg-base);
    color: var(--color-text-default);
    border-radius: var(--border-radius-border-radius-2xl) var(--border-radius-border-radius-2xl) 0 0;
    padding-block: var(--space-lg) max(var(--space-lg), env(safe-area-inset-bottom));
    overflow: hidden;

    ${desktopMedia} {
        max-width: 430px;
        border-radius: var(--border-radius-border-radius-xl);
    }
`;

export const handle = styled.div`
    flex: none;
    width: 36px;
    height: 4px;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--color-text-subtle);
    margin: 0 auto var(--space-md);

    ${desktopMedia} {
        display: none;
    }
`;

export const title = styled.span`
    flex: none;
    padding-inline: var(--space-xl);
    margin-bottom: var(--space-md);
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
`;

export const footer = styled.div`
    flex: none;
    padding: var(--space-md) var(--space-xl) 0;

    & button {
        width: 100%;
    }
`;
